module.exports = __webpack_public_path__ + "static/media/icon-security.f5585378.svg";